import { Box, Modal } from '@mantine/core';

import ProjectPermissions from '@projects/components/ProjectPermissions/ProjectPermissions';
import Project from 'src/entities/project';
import useDelayedOpening from 'src/new_arch/hooks/useDelayedOpening';
import useStackeableModal from 'src/new_arch/hooks/useStackeableModal';

export type ManageReviewerRoleModalProps = {
	project: Project;
	onClose: () => void;
	stackOrder?: number;
};

const MODAL_STYLES = {
	header: {
		borderBottom: '1px solid var(--mantine-color-gray-1)'
	}
};

const ManageReviewerRoleModal = ( {
	project,
	onClose,
	stackOrder = 1
}: ManageReviewerRoleModalProps ) => {
	const opened = useDelayedOpening();
	const {
		modalStyles, submodalsStackOrder
	} = useStackeableModal( { stackOrder, defaultStyles: MODAL_STYLES } );

	return (
		<Modal
			opened={opened}
			onClose={onClose}
			size={500}
			title="Manage Reviewer Role"
			closeButtonProps={{ size: 24 }}
			className="ManageReviewerRoleModal"
			styles={modalStyles}
			centered
		>
			<Box py={16}>
				<ProjectPermissions project={project} modalsStackOrder={submodalsStackOrder} />
			</Box>
		</Modal>
	);
};

export default ManageReviewerRoleModal;
